import { render } from "./TextContent.vue?vue&type=template&id=48313894&scoped=true&lang=html"
import script from "./TextContent.vue?vue&type=script&lang=js"
export * from "./TextContent.vue?vue&type=script&lang=js"

import "./TextContent.vue?vue&type=style&index=0&id=48313894&scoped=true&deep=true&lang=scss"
script.render = render
script.__scopeId = "data-v-48313894"

export default script